import { createSlice } from '@reduxjs/toolkit';
import {
  fetchTags,
  addTags,
  updateTags,
  deleteTag,
  removeError,
  fetchTag,
  resetDeleteStatus,
  resetUpdateStatus,
  setCandidateAddedToTag,
  addCandidateToTag,
  resetDeleteStatusCandidateTags,
  removeMultiJobCandidatesTag,
} from '../actions';

const initialState = {
  isLoading: true,
  page: 1,
  tagsCount: 0,
  tags: [],
  tag: {},
  tagCreated: false,
  tagUpdated: false,
  tagDeleted: false,
  tagsInUpdateState: [],
  deleteTagId: false,
};

const tags = createSlice({
  name: 'tags',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(setCandidateAddedToTag, (state, action) => {
      state.candidateAddedToTag = action.payload;
    });

    builder.addCase(fetchTags.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchTags.fulfilled, (state, action) => {
      const { page, items } = action.payload.paging;
      state.tags = action.payload.tags || [];
      state.isLoading = false;
      state.page = page;
      state.tagsCount = items;
      state.error = '';
      state.tagUpdated = false;
      state.tagCreated = false;
    });

    builder.addCase(fetchTags.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.error;
    });

    builder.addCase(addTags.pending, (state) => {
      state.tagCreated = false;
    });

    builder.addCase(addTags.fulfilled, (state, action) => {
      state.tagCreated = true;
      state.tag = action.payload.tag;
      state.tags.unshift(action.payload.tag);
      state.error = '';
    });

    builder.addCase(addTags.rejected, (state, action) => {
      state.tagCreated = false;
      state.error = action.payload.message;
    });

    builder.addCase(fetchTag.pending, (state) => {
      state.isLoading = true;
      state.tagUpdated = false;
    });

    builder.addCase(fetchTag.fulfilled, (state, action) => {
      state.tag = action.payload.tag;
      state.tagUpdated = false;
      state.tagCreated = false;
      state.isLoading = false;
    });

    builder.addCase(fetchTag.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    });

    builder.addCase(removeError, (state) => {
      state.error = '';
    });

    builder.addCase(resetDeleteStatus, (state) => {
      state.tagDeleted = false;
      state.tagUpdated = false;
    });

    builder.addCase(resetUpdateStatus, (state) => {
      state.tagUpdated = false;
    });

    builder.addCase(updateTags.pending, (state, action) => {
      state.tagUpdated = false;
      state.error = '';
      state.tagsInUpdateState.push(action.meta.arg.tagId);
    });

    builder.addCase(updateTags.fulfilled, (state, action) => {
      state.tagUpdated = true;
      state.tagCreated = false;
      state.tag = action.payload.tag;
      state.tagsInUpdateState = state.tagsInUpdateState.filter(
        (element) => element !== action.payload.tag.id,
      );
      state.tags = state.tags.map((tagElem) => {
        if (tagElem.id === action.payload.tag.id) {
          tagElem = action.payload.tag;
        }
        return tagElem;
      });
      state.updateTagIdWithError = '';
    });

    builder.addCase(updateTags.rejected, (state, action) => {
      state.tagUpdated = false;
      state.error = action.payload.message;
      state.tagsInUpdateState = state.tagsInUpdateState.filter(
        (element) => element !== action.meta.arg.tagId,
      );
      state.updateTagIdWithError = action.payload.message ? action.meta.arg.tagId : '';
    });

    builder.addCase(deleteTag.pending, (state) => {
      state.tagDeleted = false;
      state.isLoading = true;
    });

    builder.addCase(deleteTag.fulfilled, (state, action) => {
      state.tagDeleted = true;
      state.isLoading = false;
      state.tag = {};
      state.tags = state.tags.filter((element) => element.name !== action.meta.arg.tagName);
    });

    builder.addCase(deleteTag.rejected, (state, action) => {
      state.tagDeleted = false;
      state.isLoading = false;
      state.error = action.payload.message;
    });

    builder.addCase(addCandidateToTag.fulfilled, (state) => {
      state.candidateAddedToTag = true;
    });

    builder.addCase(resetDeleteStatusCandidateTags, (state) => {
      state.deleteTagId = false;
    });

    builder.addCase(removeMultiJobCandidatesTag.pending, (state) => {
      state.tagCandidateUpdating = true;
      state.deleteTagId = false;
    });

    builder.addCase(removeMultiJobCandidatesTag.fulfilled, (state) => {
      state.tagCandidateUpdating = false;
      state.deleteTagId = true;
    });

    builder.addCase(removeMultiJobCandidatesTag.rejected, (state, action) => {
      state.tagCandidateUpdating = false;
      state.error = action.payload.error;
      state.deleteTagId = false;
    });
  },
});

export default tags;
